import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const topicInterest = {
  createTopicInterest: lazyModuleMethod(
    () => import('./createTopicInterest'),
    'default'
  ),
  fetchTopicInterests: lazyModuleMethod(
    () => import('./fetchTopicInterests'),
    'default'
  ),
  deleteTopicInterest: lazyModuleMethod(
    () => import('./deleteTopicInterest'),
    'default'
  ),
  fetchTopicInterest: lazyModuleMethod(
    () => import('./fetchTopicInterest'),
    'default'
  ),
  updateTopicInterest: lazyModuleMethod(
    () => import('./updateTopicInterest'),
    'default'
  ),
}
